var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.sortedScenarioBatches, function(scenarioBatch) {
      return _c(
        "div",
        { key: scenarioBatch.scenarioId, staticClass: "col-3 form-group" },
        [
          _c("scenario-batch-list-item", {
            attrs: {
              scenarioBatch: scenarioBatch,
              "can-cancel":
                _vm.aggregatedScenarioValues[scenarioBatch.scenarioId]
                  .canCancel,
              "is-cancelled":
                _vm.aggregatedScenarioValues[scenarioBatch.scenarioId]
                  .isCancelled,
              "estimated-costs":
                _vm.aggregatedScenarioValues[scenarioBatch.scenarioId]
                  .estimatedCosts,
              "estimated-recipients":
                _vm.aggregatedScenarioValues[scenarioBatch.scenarioId]
                  .estimatedRecipients
            },
            on: {
              activate: function($event) {
                return _vm.activate(scenarioBatch.scenarioId)
              },
              deactivate: function($event) {
                return _vm.deactivate(scenarioBatch.scenarioId)
              }
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }